import { useQuery } from 'react-query';
import companyTefConfigurationServices from './companyTefConfiguration.services';

export function useCompanyTefConfiguration(companyId?: number, enabled = true) {
  return useQuery({
    queryKey: ['company-tef-configuraion', companyId],
    queryFn: () => companyTefConfigurationServices.isActive(companyId),
    enabled: !!companyId && enabled,
  });
}
